import { getDateWithoutTimezone } from '../../utils/getDateWithoutTimezone'
import type { TDateArg } from './date.types'
import { LocaleDateFormat } from './dayjs'

export const createDatesSentence = (from: TDateArg, to: TDateArg, format?: 'short' | 'long') => {
  const startDate = getDateWithoutTimezone(from)
  const endDate = getDateWithoutTimezone(to)
  const fromDate =
    startDate?.year() === endDate?.year()
      ? startDate?.format(LocaleDateFormat[startDate.locale()]?.[format === 'short' ? 'shortDayMonth' : 'dayMonth'])
      : startDate?.format(
          LocaleDateFormat[startDate.locale()]?.[format === 'short' ? 'shortDayMonthYear' : 'dayMonthYear'],
        )

  const toDate = endDate?.format(
    LocaleDateFormat[endDate.locale()]?.[format === 'short' ? 'shortDayMonthYear' : 'dayMonthYear'],
  )

  return [fromDate, toDate]
}
